module.exports = __webpack_public_path__ + "static/media/office@2x.9efaa8a3.jpg";